const REGEX = {
  zipCode: /^\d{4}\s?[a-zA-Z]{2}$/,
  iban: /^NL\d{2}[A-Z]{4}\d{10}$/,
  birthDate: /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/,
  phoneNumber: /^\d{10}$/,
  houseNumber: /^[1-9]\d*$/,
  houseNumberAddition: /^[a-zA-Z0-9\s\-/]{0,10}$/,
  city: /^[a-zA-ZÀ-ÿ]+(?:[ .'-][a-zA-ZÀ-ÿ]+)*(?:\s\([a-zA-ZÀ-ÿ. ]+\))?$/,
  street: /^[a-zA-ZÀ-ÿ0-9\s\-'.]+$/
}

export default REGEX
